import React, { useEffect, useState } from 'react'
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import CancelIcon from '@mui/icons-material/Cancel';
import Button from "@mui/material/Button";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Alert, CircularProgress, InputBase, Menu, MenuItem, Typography } from '@mui/material';
import { useRef } from "react";

import { styled, alpha } from "@mui/material/styles";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getFirebaseAuthModule } from '../../Repository/Authentication/Firebase';
import { baseURL, getCamiCode, getCamiCodeImage, getUserByEmail } from '../../Repository/Api';
import { Link, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import camiCodeImg from '../../assets/images/camiCode/camiCodeImg'
import { useLocation } from 'react-router-dom';
import { downloadFile } from '../../Business/MediaBusiness';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSate } from 'react';
import { saveAs } from 'file-saver';
import FileSaver from 'file-saver';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import ShareReceivedCamiCode from '../Components/ShareReceivedCamiCode';
import { sendToUser } from '../../Repository/Api';

// import downloadImg from './../../assets/images/buttonIcons/download.svg'


function CamiCardReceived(props) {
    const theme = useTheme();
    const [data, setData] = useState([]);
    const [id, setId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [imageResponse, setImageResponse] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [toEmail, setToEmail] = useState("");
    const [currentUserId, setCurrentUserId] = useState("");
    const [dataToShare, setDataToShare] = useState("");
    const [userName, setUserName] = useState("");
    const [message, setMessage] = useState(false);
    // const [email, setEmail] = useState("");
    const mainColor = theme.palette.primary.main;
    const whiteColor = "#000";
    const inputFieldColor = "#EEF0F3";
    const [receiverInfo, setReceiverInfo] = useState("");
    const [propReceiverSubject, setPropReceiverSubject] = useState("");
    const [emailFromUrl, setEmailFromUrl] = useState("");
    const [fromSubject, setFromSubject] = useState("");
    const [pass, setPass] = useState("");
    const [camiId, setCamiId] = useState('');
    const [loggedUser, setLoggedUser] = useState('');
    const [camiType,setCamiType] = useState('');
    const navigate = useNavigate();
    const matches = useMediaQuery(theme.breakpoints.down("md"));
    // const [formName, setFormName] = useState('');
    // const [formToName, setFormToName] = useState('');
    // const [formToEmail, setFormToEmail] = useState('');
    // const [formSubject, setFormSubject] = useState('');
    const emailValue = '';
    let _location = useLocation();
    let _fromRoute = _location.state?.from?.pathname;
    const currentURL = window.location.href;
    const currentURLPath = window.location.pathname;
    // localStorage.setItem("RETURNURL", currentURL)
    // localStorage.setItem("RETURNPATH", currentURLPath)
    // console.log(currentURL, 'current location')
    // console.log(currentURLPath, 'current pathname')
    //     console.log(_fromRoute)
    // const fromName = fromNameRef.current.value
    // useEffect(() => {
    //     if (localStorage.getItem("RETURNPATH")) {
    //         localStorage.removeItem("RETURNPATH")
    //         localStorage.setItem("RETURNPATH", currentURLPath)

    //     }
    // }, [])

    const CustomButton = styled(Button)(({ theme }) => ({
        color: "#FFFFFF",
        backgroundColor: theme.palette.secondary.main,
        borderRadius: 999,
        fontWeight: 600,
        textTransform: "none",
        boxShadow: "0 4px 14px rgba(153, 6, 14, 0.28)",
        transition: "background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            boxShadow: "0 6px 18px rgba(153, 6, 14, 0.35)",
        },
    }));
    const containerStyle = {
        backgroundColor: "#fff",
        width: 110,
        height: 140,
        elevation: 2,
        margin: 0.5
    }
    const descriptionStyle = {
        fontSize: 10,
        textDecoration: "none",
        // textOverflow: 'ellipsis',
        // width: '200px',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        fontWeight: "bold",
        minHeight: "20px"
    }
    const titleStyle = {
        fontSize: 10,
        fontWeight: "bold"
    }

    const imgStyle = {
        width: 150, paddingLeft: 30, paddingRight: 30, resize: "cover",
        paddingBottom: 10,
    }

    const logoImage = {
        maxHeight: "400",
        maxWidth: "400",
        paddingBottom: "3px",
    };
    const buttonStyle = {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#9c27b0",
        color: "white",
        borderRadius: "25px",
        // height:"100%",
        fontSize: "10px",
        height: "30px",
        textTransform: "capitalize",
    };
    const printCodeStyle = {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#8ccccc",
        borderRadius: "30px",
        fontSize: "10px",
        height: "30px",
        textTransform: "capitalize"
    };
    const sentToStyle = {
        fontSize: 16,
        textAlign: "start",
        padding: 0,
        fontWeight: "bold",
        width: '150px',
        minHeight: "20px",

    }

    const hide = {
        display: "none"
    }


    // get camitag ID from url
    useEffect(() => {
        console.log("INSIDE CONSTRUCTOR SECTION");
        const camiCodeId = getCamitagFromUrl();
        console.log('CAMICODE: ', camiCodeId);
        // if (localStorage.getItem('CAMIID')) {
        //     localStorage.removeItem('CAMIID')
        // }
        // localStorage.setItem('CAMIID', camiCodeId)

        setId(camiCodeId)
        // if (localStorage.getItem('CREATEDCAMI')) {
        //     localStorage.removeItem('CREATEDCAMI');
        //     localStorage.setItem('RECEIVEDCAMI', window.location.search)
        //     if (localStorage.getItem('CCP')) {
        //         localStorage.removeItem('CCP')
        //         localStorage.setItem('RCP','RCP')
        //     }
        // }
        // localStorage.setItem('RECEIVEDCAMI', window.location.search)
        // localStorage.setItem('RCP','RCP')
        getReceiverEmailFromUrl();
    }, []);

    function getReceiverEmailFromUrl() {
        const urlSearchParams = new URLSearchParams(window.location.search.toString().slice(1));
        if (urlSearchParams.has('e')) {
            const emailOfReceiver = urlSearchParams.get('e').replace(/ /g, '');
            setEmailFromUrl(emailOfReceiver)
        }
        console.log(urlSearchParams);
    }

    useEffect(() => {
        if (id) {
            requestData();
        }
    }, [id]);

    let getCamitagFromUrl = () => {
        return getCamitag(window.location);
    }

    let getCamitag = (url) => {
        try {
            const urlparams = new URLSearchParams(url.search);
            console.log("URL PARAMS: ", urlparams);
            const _camitagid = urlparams.get('c') || "";
            return _camitagid;
        } catch (error) {
            return "";
        }
    }
    // get camitag ID from url
    const CustomIconButton = styled(IconButton)(({ theme }) => ({
        color: theme.palette.getContrastText(whiteColor),
        padding: '5px',
        backgroundColor: mainColor,
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
        },
    }));

    //get corresponding camicode from API - getCamiCodeByID
    function requestData() {
        // const auth = getFirebaseAuthModule();
        // console.log(auth);

        // if (!auth.currentUser) {
        //     console.log('user not authenticated');
        //     return ((error => console.error))
        // } else {


        console.log('user authenticated');
        setIsLoading(true);
        getCamiCode(id, pass).then((data) => {
            setData(data);
            console.log(data.camiTypeId,'camiType');
            setCamiType(data.camiTypeId)
            setIsLoading(false);
        }).catch((error) => {
            console.error('Data retrieval failed');
        });
        // }
    }
    useEffect(() => {
        fetchReceieverInfoIfLoggedOut();
    }, [emailFromUrl, id, pass])

    function fetchReceieverInfoIfLoggedOut() {
        if (emailFromUrl && id && pass) {
            console.log(emailFromUrl)
            const token = 'Bearer ' + localStorage.getItem('JWTTOKEN');
            let api = baseURL + '/api/CamiCode/GetReceiverCamiCodeDetByEmail?email=' + emailFromUrl + '&camiCode=' + id + '&uniqueId=' + pass;
            fetch(api, {
                method: "GET",
                cache: "no-cache",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            }).then((response) => response.json()).then((result) => {
                console.log(result);
                setCamiId(result.id)
                setLoggedUser(result.videoCreatedBy)
                setFromSubject(result);
            })
        }
    }

    //get corresponding camicode from API - getCamiCodeByID
    function handleCloseClick() {
        navigate("/received-qrcode")
    }

    const downloadVideoURL = 'https://cdn.api.video/vod/' + data['videoId'] + '/mp4/source.mp4'
    const camiTagImage = baseURL + '/api/CamiCode/GenerateQrCode?camiCode=' + id;
    const downLoadImage = baseURL + '/api/CamiCode/DownloadQrCode?camiCode=' + id;
    const watchUrl = (emailFromUrl) ? ('/watch?c=' + data.camiCode  + '&redir=' + encodeURIComponent('/qrcard-received') + '&e=' + emailFromUrl + '&p=' + pass) : ('/watch?c=' + data.camiCode + '&redir=' + encodeURIComponent('/qrcard-received') + '&p=' + pass);

    const handleClickOpenModal = () => {
        setOpenModal(true);
    };
    function handleCancelModal() {
        console.log('hide modal')
        setOpenModal(false);
        clearStorage();
    };
    function handleCloseModal(e) {
        console.log('inside close modal')
        setOpenModal(false);
        handleSend(e);
    };
    const handleSend = (e) => {
        networkCall()
        console.log("network call done")
    }

    
    const fetchData = async (user) => {
        try {
            const getUserDetails = await getUserByEmail(user)
            if (getUserDetails['id']) {
                setCurrentUserId(getUserDetails?.id);
                setUserName(getUserDetails.firstName);
                console.log(getUserDetails.firstName, "printing userdetails")
                console.log(currentUserId, "Print user ID of current User")
            }

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const auth = getFirebaseAuthModule();
        auth.onAuthStateChanged((user) => {
            if (user) {
                user.getIdToken().then((newToken) => {
                    localStorage.setItem("JWTTOKEN", newToken);
                    fetchData(user.email);
                });
            } else if (user = undefined || null) {
                fetchData(user.email);
            }
        }
        );
        getPasswordFromQuery();

    }, []);

    function getPasswordFromQuery() {
        const urlSearchParams = new URLSearchParams(window.location.search.toString().slice(1));

        if (urlSearchParams.has('p')) {
            console.log('inside has p')
            const _pass = urlSearchParams.get('p').replace(/ /g, '');
            console.log(_pass);
            // const decodedPathName = decodeURI(redirPath);
            setPass(_pass);
        }
    }
    function getReceivedDetails() {
        if (currentUserId && id && pass) {
            const token = 'Bearer ' + localStorage.getItem('JWTTOKEN');
            const _baseUrl = baseURL + "/api/CamiCode/GetReceiverCamiCodeDet"
            const params = new URLSearchParams({
                userId: currentUserId,
                camiCode: id,
                uniqueId: pass

            });
            fetch(_baseUrl + '?' + params.toString(), {
                method: "GET",
                mode: "cors",
                headers: {
                    'content-Type': 'application/json',
                    'Authorization': token
                },
            }).then((res) => res.json()).then((result) => {
                console.log(result,'received result')
                setCamiId(result.id);
                setLoggedUser(result.videoCreatedBy)
                setReceiverInfo(result)
                setPropReceiverSubject(result?.subject)
                console.log(receiverInfo)
            }).catch((error) => {
                console.log(error);
            });
        }
    }
    useEffect(() => {
        getReceivedDetails();
    }, [currentUserId, id])

    function clearStorage() {
        localStorage.removeItem('CURRENTNAME');
        localStorage.removeItem('TOEMAIL');
        localStorage.removeItem('TONAME');
        localStorage.removeItem('TOSUBJECT');
    }
    function networkCall() {
        console.log("inside network call")
        const formName = localStorage.getItem('CURRENTNAME');
        const formToEmail = localStorage.getItem('TOEMAIL');
        const formToName = localStorage.getItem('TONAME');
        const formSubject = localStorage.getItem('TOSUBJECT');
        clearStorage();
        console.log(id, formName, currentUserId, formToName, formToEmail)
        if (id && formName && formToName && formToEmail) {
            const _payload = {
                "fromName": formName,
                "toName": formToName,
                "email": formToEmail,
                "subject": formSubject,
                "camiCodeId": id,
                "userId": 0,
                "loggedUser": (currentUserId) ? (currentUserId) : (0)
            };
            // localStorage.clear();
            console.log(_payload);
            setDataToShare(_payload);
            sendToUser(_payload).then((res) => {
                if (res) {
                    console.log(res);
                    setMessage(true)
                } else {
                    console.log("error sending camicode")
                }
            }).catch((error) => {
                // display error message.
            });
        }
    }

    function handleWatch() {
        // localStorage.setItem('RECEIVEDCAMI', window.location.search);
        window.open(watchUrl, "_blank")
    }

   


    async function handleDownload() {

        let blob = await fetch(downLoadImage).then((v) => v.blob())
        FileSaver.saveAs(blob, "QR.jpeg");
    }


    function DownloadDropDown() {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        return (
            <React.Fragment>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

                    <Tooltip title="Select download option">
                        <CustomIconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <DownloadIcon />
                        </CustomIconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={handleDownload}>
                        <a style={{ textDecoration: "none" }} target="_blank">QRCode</a>
                    </MenuItem>
                    <MenuItem onClick={() => downloadFile(downloadVideoURL)}>
                        Video
                    </MenuItem>

                </Menu>
            </React.Fragment>
        );
    }

    const dialog = () => {
        return (
            <Dialog open={openModal} onClose={handleClickOpenModal}>
                <DialogTitle sx={{ paddingBottom: 0 }}>Share QR Code </DialogTitle>
                <DialogContent>
                    <ShareReceivedCamiCode
                        fromCurrentUserName={userName}
                        currentSubject={propReceiverSubject}
                        handleCancelModal={handleCancelModal}
                        handleCloseModal={handleCloseModal}
                        shareSubject={fromSubject.subject} />
                </DialogContent>
                <DialogActions sx={{ alignSelf: "center" }}>
                </DialogActions>
            </Dialog>
        )
    }

    function RenderAllContent() {
        const [open, setOpen] = useState(false);

        const handleClickAlert = () => {
            setOpen(true);
        };
        return (<>{renderCamiCard()}</>);
       
    }
    const renderCamiCard = () => {
        if (id) {
            return (<Box sx={{ margin: '0 auto' }}>
                <Box sx={{ textAlign: "center" }} >
                    <Typography sx={{ color: mainColor }} gutterBottom variant="h5" component="div">
                        Received QRCode
                    </Typography>
                </Box>
                <Paper sx={{ padding: 2, width: 260, margin: '0 auto' }}>
                <div style={((camiType== 3) == false  )? {} : hide}>
                    <Box sx={{ textAlign: "right", width: "100%" }}>
                        <Tooltip
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            title={("Your video will remain live for " + receiverInfo.remainingDays || fromSubject.remainingDays + " more days, download to keep forever")}>
                            <Typography sx={{ textAlign: "right" }}> {receiverInfo.remainingDays || fromSubject.remainingDays}/60 days</Typography>
                        </Tooltip>
                    </Box>
                </div>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", }}>
                        <Button sx={{ right: -26, top: -12, width: 25, height: 25, elevation: 2 }}
                            onClose={handleCloseClick}
                            disabled
                        // endIcon={<CancelIcon />}
                        ></Button>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        <img src={camiTagImage} style={{ height: 150 }}></img>
                    </Box>
                    <Box sx={{ marginLeft: 1, paddingTop: 2, paddingBottom: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography variant="h6" sx={sentToStyle}>  {(receiverInfo?.fromName) ? (receiverInfo?.fromName) : ("") || (fromSubject?.fromName) ? (fromSubject?.fromName) : ("")}</Typography>

                    </Box>
                    <Box sx={{ marginLeft: 1, width: "100%", marginBottom: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", }}>
                        <Typography variant="p" fontSize={10} sx={descriptionStyle}>{(receiverInfo?.subject) ? (receiverInfo?.subject) : ("") || (fromSubject?.subject) ? (fromSubject?.subject) : ("")}</Typography>
                    </Box>
                    <Box sx={{ paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        {/* <a style={{ textDecoration: "none" }} target="_blank">
                            <Tooltip
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 600 }}
                                title="Download QR Code">
                                <CustomIconButton
                                    variant="contained"
                                    // sx={buttonStyle}

                                    onClick={handleDownload}
                                > <QrCodeScannerIcon />

                                </CustomIconButton></Tooltip></a> */}
                        {DownloadDropDown()}
                        <Tooltip
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            title="Share QR Code">
                            <CustomIconButton
                                variant="contained"
                                // sx={printCodeStyle}
                                onClick={handleClickOpenModal}
                            >
                                <ShareIcon />
                            </CustomIconButton>
                        </Tooltip>
                        <Tooltip
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            title="Play Video or Preview Image/PDF">
                            <CustomIconButton
                                onClick={handleWatch}
                                aria-label="Play"
                                sx={{ borderRadius: 25, }} >
                                < PlayArrowIcon />
                            </CustomIconButton>
                        </Tooltip>
                        {/* <Tooltip
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            title="Download Video">
                            <CustomIconButton
                                aria-label="Download"
                                onClick={() => downloadFile('https://cdn.api.video/vod/' + data['videoId'] + '/mp4/source.mp4')}
                                sx={{ borderRadius: 25, }}  >
                                <DownloadIcon />
                            </CustomIconButton>
                        </Tooltip> */}
                        {dialog()}
                    </Box>

                </Paper>
            </Box>
            )
        } else {
            return null;
        }
    }
    const handleCloseAlert = () => {
        setMessage(false);
    };

    if (isLoading) {
        return <Box sx={{ width: '100%', textAlign: 'center', paddingTop: '150px' }} ><CircularProgress sx={{ position: 'relative', width: '100%', margin: '0 auto' }} /></Box>
    } else if (message) {
        return (
            <>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "80vh", minWidth: "50vw", textAlign:'center'}}>
                    <Alert onClose={handleCloseAlert} severity="success" >
                        QR Code Shared!
                    </Alert>
                </Box>
            </>
        );
    } else  {
        return (<>
            <Box sx={{ color: "#b157b0", marginLeft: 2, marginBottom: 3, marginTop: 5, fontSize: 15 }}>
                {/* <Typography variant="h6">
                    Created QR Codes
                </Typography> */}
            </Box>
            {matches ? (<Box sx={{ width: "100vw", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <RenderAllContent></RenderAllContent>
            </Box>) : (
                <Box sx={{ marginBottom: 2, display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: 2 }}>
                    <RenderAllContent></RenderAllContent>
                </Box>
            )}
        </>
        )
    }
}

export default CamiCardReceived;
